import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter = {
  path: '/expertConclusionManage',
  redirect: 'expertConclusionManage',
  name: 'expertConclusionManage',
  component: Layout,
  children: [
    {
      path: 'expertConclusionManage',
      component: () => import('@/views/expertConclusionManage/index.vue'),
      name: 'expertConclusionManage',
      meta: {
        title: '结题评审',
        icon: 'tissue',
        requireAuth: true,
      }
    }
  ]
}

export default equipRouter
